const padding = {
  padding: "12",
  paddingTop: "20",
  paddingRight: "12",
  paddingBottom: "12",
  paddingLeft: "12",
};

const margin = {
  margin: "0",
  marginTop: "0",
  marginRight: "0",
  marginBottom: "0",
  marginLeft: "0",
};

const dimension = {
  height: "100",
  width: "100",
  heightMode:"%",
  widthMode:"%"
};

const position = {
  absolute: false,
  top: "0",
  right: "0",
  bottom: "0",
  left: "0"
}

const align = {
  alignX: "",
  alignY: "",
};

const deviceStyles = {
  ...padding,
  ...margin,
  ...dimension,
  ...align,
  ...position,
};

export const gridStyles = {
  common: {
    backgroundColor: "#FFFFFF",
  },
  Lg: {
    gridCols: "3",
    gridRows:"0",
    padding: {},
    layout: "Flex",
    flexDirection: "Column",
    flexAlignItems: "Normal",
    flexJustifyContent: "Normal",
    gridAutoRows: "auto-rows-min"
  },
  Md: {
    gridCols: "2",
    gridRows:"0",
    padding: {},
    layout: "Flex",
    flexDirection: "Column",
    flexAlignItems: "Normal",
    flexJustifyContent: "Normal",
    gridAutoRows: "auto-rows-min"
  },
  Sm: {
    gridCols: "1",
    gridRows:"0",
    padding: {},
    layout: "Flex",
    flexDirection: "Column",
    flexAlignItems: "Normal",
    flexJustifyContent: "Normal",
    gridAutoRows: "auto-rows-min"
  },
};

export const styles = {
  common: {
    border: "0",
    borderRadius: "0",
    fontSize: "16",
    fontWeight: "400",
    backgroundColor: "",
    color: "",
    borderColor: "",
  },
  Sm: {
    gridCols: "1",
    gridRows:"0",
    span: "",
    rowSpan:"1",
    visible: true,
    ...deviceStyles,
  },
  Md: {
    gridCols: "6",
    gridRows:"0",
    span: "",
    rowSpan:"1",
    visible: true,
    ...deviceStyles,
    paddingTop: "28"
  },
  Lg: {
    gridCols: "12",
    gridRows:"0",
    span: "",
    rowSpan:"1",
    visible: true,
    ...deviceStyles,
    paddingTop: "32"
  },
};

export const containers = ['Grid', 'ExpansionPanel', 'Row', 'Column','TabBar',"Tab", 'CustomModal', 'A8Modal', "FlatList", 'SnackBar', 'Container','FormWizard', 'FormWizardStep']
export const conditionalElements = ['A8Modal', 'CustomModal']
export const wrapperLessElements = ['FAB']
export const canvasElements = [...conditionalElements, ...wrapperLessElements]
